var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-list',{attrs:{"title":_vm.title,"title-color":"teal"}},[_c('v-mapping-list-messages'),_c('v-mapping-list-input'),_c('v-mapping-list-values'),_c('v-mapping-list-similar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }